export default __webpack_public_path__ + "static/bg-d9f1ee5c707ce9532e5e9350e7a60eda.png";